// @flow
import {
    LOGIN_USER,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAILED,
    LOGOUT_USER,
    REGISTER_USER,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAILED,
    FORGET_PASSWORD,
    FORGET_PASSWORD_SUCCESS,
    FORGET_PASSWORD_FAILED, REFRESH_USER_PROFILE_SUMMARY
} from '../../constants/actionTypes';
import {userService} from './services';
import {alertActions } from '../actions'
import {history} from "../../helpers";


type AuthAction = { type: string, payload: {} | string };

// export const loginUser = (username: string, password: string): AuthAction => {
    
//     return dispatch => {
//         dispatch(request({ username }));
//         userService.login(username, password)
//             .then(
//                 user => {
                 
//                     if(user.data.status == "blocked"){
                       
//                          dispatch(success(user.data));
//                     history.push('/request');
//                     dispatch(alertActions.success(user.message.toString()));
//                     // window.location.reload();
//                     }else{

//                     dispatch(success(user.data));
//                     history.push('/');
                    
//                     // history.push('/casino?category=VIDEOSLOTS');
//                     dispatch(alertActions.success(user.message.toString()));
                  
//                         // setTimeout(() => {
//                         //  window.location.reload();
//                         // }, 1000);
//                     }
//                    console.log('signin user.data.status')
//                 },
//                 error => {
//                     if(error == "your account is blocked by Self Exclusion."){
                       
//                            history.push('/request');
//                             window.location.reload();
//                     }
                  
//                     dispatch(failure(error.toString()));
//                     //dispatch(alertActions.error(error.toString()))
//                 }
//             );
//     }
//     function request(user) {
//         return {type: LOGIN_USER, user}
//     }
//     function success(user) {
//         return {type: LOGIN_USER_SUCCESS, payload: user}
//     }
//     function failure(error: string) {
//         return {type: LOGIN_USER_FAILED, payload: error}
//     };
// };


export const loginUser = (username: string, password: string): any => {
  return (dispatch) => {
    dispatch(request({ username }));

    // ✅ return the promise so calling code can await it
    return userService.login(username, password).then(
      (user) => {
        if (user.data.status === "blocked") {
          dispatch(success(user.data));
          history.push("/request");
          dispatch(alertActions.success(user.message.toString()));
          return { success: true }; // ✅ return success
        } else {
          dispatch(success(user.data));
          history.push("/");
          dispatch(alertActions.success(user.message.toString()));
          return { success: true }; // ✅ return success
        }
      },
      (error) => {
        if (error === "Your account has been blocked due to Time Out or Self Exclusion. Please contact admin for unblocking.") {
          history.push("/request");
          window.location.reload();
        }

        dispatch(failure(error.toString()));
        return { success: false }; // ✅ return failure
      }
    );
  };

  function request(user) {
    return { type: LOGIN_USER, user };
  }

  function success(user) {
    return { type: LOGIN_USER_SUCCESS, payload: user };
  }

  function failure(error: string) {
    return { type: LOGIN_USER_FAILED, payload: error };
  }
};


export const registerUser = (user: Object, email: string): AuthAction => {
    return (dispatch: Function) => {
        dispatch(request(user));

        userService.signup(user, email)
            .then(
                (response) => {
                    console.log('signupdata', response);
                    dispatch(success(response));
                },
                (error) => {
                    console.log('signuperror', error);
                    dispatch(failure(error.toString()));
                }
            );
    };
   
    function request(user: {}) {
        return {type: REGISTER_USER, payload: user}
    }
    function success(user: {}) {
        return {type: REGISTER_USER_SUCCESS, payload: user}
    }
    function failure(error: string) {
        return {type: REGISTER_USER_FAILED, payload: error}
    };
};

export const registerUser2 = (user: Object,email,username,password): AuthAction => {
    return dispatch => {
        dispatch(request(user,email));
        userService.signup2(user,email,username,password)
            .then(
                user => {
                    console.log('signupdata',user)
                    dispatch(success(user));
                
                   history.push({pathname:"/login",state:{user:user} });
                   dispatch(alertActions.success(user.message.toString()));
                   window.location.reload();
                   
                },
                error => {
                    dispatch(failure(error.toString()));
                    //dispatch(alertActions.error(error.toString()))
                }
            );
    }
   
    function request(user: {}) {
        return {type: REGISTER_USER, payload: user}
    }
    function success(user: {}) {
        return {type: REGISTER_USER_SUCCESS, payload: user}
    }
    function failure(error: string) {
        return {type: REGISTER_USER_FAILED, payload: error}
    };
};


export const logoutUser = (history: any): AuthAction => ({
    type: LOGOUT_USER,
    payload: { history }
});

export const forgetPassword = (username: string): AuthAction => ({
    type: FORGET_PASSWORD,
    payload: { username }
});

export const forgetPasswordSuccess = (passwordResetStatus: string): AuthAction => ({
    type: FORGET_PASSWORD_SUCCESS,
    payload: passwordResetStatus
});

export const forgetPasswordFailed = (error: string): AuthAction => ({
    type: FORGET_PASSWORD_FAILED,
    payload: error
});

export const refreshProfileSummary = () => {
  
    return dispatch => {
        userService.refreshProfileSummary()
            .then(
                user => {
                    dispatch(success(user));
                },
                error => {
                    console.log(error);
                }
            );
    }
    function success(user: {}) {
        return {type: REFRESH_USER_PROFILE_SUMMARY, payload: user}
    }
};
